// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mobile-bind-group[data-v-80dd8ace]{margin-top:15px;line-height:24px;font-size:13px;color:#999;background:#fafafa;padding:10px 20px}.popover-slider-bar .form-container .form-item .form-label[data-v-80dd8ace]{width:90px!important}", ""]);
// Exports
module.exports = exports;
